import React from 'react';
import { FormattedMessage } from 'react-intl';

import ConfirmAccount from 'Components/Account/ConfirmAccount';
import OrderList from 'Containers/Order/OrderList';

import 'Components/Account/OrdersAndKeys/OrdersAndKeys.scss';

export default function OrdersAndKeys() {
  return (
    <section className="account-content orders-and-keys">
      <ConfirmAccount />
      <h1>
        <FormattedMessage id="account-orders-and-keys.heading" defaultMessage="Order History & Keys" />
      </h1>
      <p>
        <FormattedMessage
          id="account-orders-and-keys.orders.body"
          defaultMessage="To view an order in more detail, and to view the keys associated with that order, simply click on {boldOrderKeys} for the appropriate order."
          values={{
            boldOrderKeys: <b><FormattedMessage id="account-orders-and-keys.viewordersandkeys" defaultMessage="View Order & Keys" /></b>,
          }}
        />
      </p>
      <OrderList />
    </section>
  );
}
